import constants from '../services/constants';
import { atom } from 'recoil';

const teamRoleNameWidthAtom = atom<string>({
    key: constants.teamRoleNameWidthAtom,
    default: '80px',
});

export default teamRoleNameWidthAtom;